import { FunctionComponent } from 'react';

import '../../style/ui/footer.css';

const Footer:FunctionComponent = () => {
  return (
    <footer className='container footer'>
      <p>Made by Viktor P. © 2023</p>
    </footer>
  );
};

export default Footer;
